/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ExtensionInputs */

const en_entity_extension = /** @type {(inputs: Entity_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

const de_entity_extension = /** @type {(inputs: Entity_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchwahl`)
};

/**
* | output |
* | --- |
* | "Extension" |
*
* @param {Entity_ExtensionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_extension = /** @type {((inputs?: Entity_ExtensionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ExtensionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_extension(inputs)
	return de_entity_extension(inputs)
});